import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Menu, Commands } from '../../config'
import Fuse from 'fuse.js'
import uuid from 'uuid/v4'

class CommandPalette extends Component {
  constructor (props) {
    super(props)
    this.state = {
      visible: false,
      keys: {
        91: false,
        16: false,
        80: false
      },
      location: 1,
      data: [],
      results: []
    }
  }
  componentDidMount () {
    document.addEventListener('keyup', (event) => {
      if ((event.keyCode === 91 || event.keyCode === 16 || event.keyCode === 80)) {
        this.setState({
          keys: {
            91: false,
            16: false,
            80: false
          }
        })
      }
    })
    document.addEventListener('keydown', (event) => {
      if ((event.keyCode === 91 || event.keyCode === 93 || event.keyCode === 16 || event.keyCode === 80)) {
        setTimeout(() => {
          this.setState({
            keys: {
              ...this.state.keys,
              [event.keyCode]: false
            }
          })
        }, 1000)
        this.setState({
          keys: {
            ...this.state.keys,
            [event.keyCode]: true
          }
        })
      } else if (this.state.visible && event.keyCode === 27) {
        this.setState({visible: false})
      } else if (this.state.visible && event.keyCode === 13) {
        this.execute(this.state.results[this.state.location - 1])
        this.setState({visible: false})
      } else if (this.state.visible && event.keyCode === 40) {
        let pos = this.state.location + 1
        if (pos > this.state.results.length) pos = 1
        this.setState({location: pos})
      } else if (this.state.visible && event.keyCode === 38) {
        let pos = this.state.location - 1
        if (pos < 1) pos = this.state.results.length
        this.setState({location: pos})
      }
      if ((this.state.keys['91'] || this.state.keys['93']) && this.state.keys['16'] && this.state.keys['80']) {
        this.setState({visible: true})
      }
      return true
    }, false)
    document.addEventListener('keyup', (event) => {
      if ((event.keyCode === 91 || event.keyCode === 16 || event.keyCode === 80)) {
        this.setState({
          keys: {
            ...this.state.keys,
            [event.keyCode]: false
          }
        })
      }
    }, false)
    var links = []
    links = links.concat(Commands)
    Object.values(Menu.items).forEach(item => {
      links = links.concat(
        item.children.map(link => {
          return {
            color: 'label-info',
            type: 'Navigate',
            title: item.title,
            subtitle: link.text,
            onSelect: function () {
              window.location = link.location
            }
          }
        })
      )
    })
    this.setState({data: this.state.data.concat(links), results: this.state.data.concat(links)})
  }
  componentDidUpdate () {
    if (this.state.visible) {
      document.getElementById('command-palette-field').focus()
    }
  }
  search (event) {
    if (event.keyCode === 38 || event.keyCode === 40) return false
    var value = event.target.value.replace(/\s+/g, '')
    if (value === '') return this.setState({results: this.state.data})
    var fuse = new Fuse(this.state.data, {
      shouldSort: true,
      threshold: 0.3,
      tokenize: true,
      matchAllTokens: true,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 0,
      keys: ['title', 'subtitle']
    })
    this.setState({location: 1, results: fuse.search(value)})
  }
  execute (result) {
    result.onSelect.call(this)
    this.commandInput.value = ''
    this.setState({visible: false})
  }
  render () {
    var i = 0
    return (
      <div className={'command-palette-wrapper ' + (this.state.visible ? '' : 'hidden')}>
        <div className='command-palette'>
          <div className='command-palette-input'>
            <div className='input-group'>
              <span className='input-group-addon'><i className='fa fa-fw fa-terminal' /></span>
              <input
                ref={el => (this.commandInput = el)}
                type='text'
                className='form-control'
                id='command-palette-field'
                placeholder='Search...'
                onKeyDown={(e) => {
                  this.search(e)
                }}
                onKeyUp={(e) => {
                  this.search(e)
                }} />
            </div>
          </div>
          <div className='command-palette-results list-group'>
            {this.state.results.map(result => {
              i = i + 1
              return (
                <a key={uuid()} onClick={(e) => { this.execute(result) }} className={'list-group-item ' + (this.state.location === i ? 'active' : '')}>
                  <span className={'label ' + result.color}>{result.type}</span>
                  <b>{result.title}</b>
                  <small>{result.subtitle}</small>
                </a>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}
// eslint-disable-next-line
CommandPalette = connect(state => state.siteReducer)(CommandPalette)
export default CommandPalette



// WEBPACK FOOTER //
// ./src/components/core/CommandPalette.js